import { FC, PropsWithChildren } from "react";

const ErrorView: FC<PropsWithChildren> = ({ children }): JSX.Element => {
  return (
    <div className="ErrorView py-80 px-24">
      <p className="ErrorView__content font-bold text-secondary">{children}</p>
    </div>
  );
};

export default ErrorView;
